import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class PortalSeoHelper {
  constructor(private titleService: Title, private metaService: Meta) {}

  isPortalStandardContentPage(pageData: any): boolean {
    return pageData?.documentTypeAlias === 'portalStandardContentPage';
  }

  updateSeoTags(pageData: any): void {
    if (!pageData) {
      return;
    }

    const title =
      pageData.metaTitle ||
      pageData.pageTitle ||
      pageData.name ||
      document.title;

    this.titleService.setTitle(title);

    this.updateMetaTag('description', pageData.metaDescription);
    this.updateMetaTag('keywords', pageData.metaKeyWords);

    this.updateMetaProperty('og:title', title);
    this.updateMetaProperty('og:description', pageData.metaDescription);
    this.updateMetaProperty('og:type', 'website');
  }

  clearSeoTags(): void {
    this.updateMetaTag('description');
    this.updateMetaTag('keywords');

    this.updateMetaProperty('og:title');
    this.updateMetaProperty('og:description');
    this.updateMetaProperty('og:type');
  }

  updateDefaultPortalTitle(generalSettingsData: any): void {
    if (!generalSettingsData) {
      return;
    }

    const title =
      generalSettingsData.userDetails?.sessionSiteViewType === 1
        ? generalSettingsData.portalGeneralSettingsData?.studentPortalSiteTitle
        : generalSettingsData.portalGeneralSettingsData?.staffPortalSiteTitle;

    if (title) {
      this.titleService.setTitle(title);
    }
  }

  private updateMetaTag(name: string, content?: string): void {
    if (content) {
      this.metaService.updateTag({ name, content });
      return;
    }

    this.metaService.removeTag(`name='${name}'`);
  }

  private updateMetaProperty(property: string, content?: string): void {
    if (content) {
      this.metaService.updateTag({ property, content });
      return;
    }

    this.metaService.removeTag(`property='${property}'`);
  }
}
